import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";

class PreorderMessage extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMessage);
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMessage);
  }

  /**
   * Swaps in the message rendered for the newly selected variant. Variants without a
   * pre-order message render an empty, `hidden` element. `childrenOnly` morphing never
   * touches the wrapper's own attributes, so `hidden` has to be mirrored by hand —
   * otherwise the block would keep its padding and its flex gap once emptied.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateMessage = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Skip if no HTML (cache hit - will sync via background fetch)
    if (!event.detail.data.html) return;

    // Find the correct preorder-message in HTML by matching productId
    // This prevents taking the message from a different product (e.g. recommendations)
    const productId = this.dataset.productId;
    let newMessage = null;

    if (productId) {
      const allMessages = event.detail.data.html.querySelectorAll("preorder-message");
      for (const message of allMessages) {
        if (message.dataset.productId === productId) {
          newMessage = message;
          break;
        }
      }
    }

    // Fallback: if no productId match, use first message (for single product pages)
    if (!newMessage) {
      newMessage = event.detail.data.html.querySelector("preorder-message");
    }

    if (!newMessage) return;

    morph(this, newMessage, { childrenOnly: true });
    this.toggleAttribute("hidden", newMessage.hasAttribute("hidden"));
  };
}

if (!customElements.get("preorder-message")) {
  customElements.define("preorder-message", PreorderMessage);
}
